import {
  aCustomInsight,
  aCustomInsightPage,
  aDynamicInsightSeverity,
  CustomInsight,
  mockCustomInsightQueryQuery,
  mockCustomInsightsQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

const baseCustomInsightOverrides: Partial<CustomInsight> = {
  dynamicSeverity: [
    aDynamicInsightSeverity({
      minimumSignalSeverity: 0,
    }),
  ],
};

export const getMockCustomInsightQuery = (
  customInsight: Partial<CustomInsight>
) => ({
  __typename: 'Query',
  customInsight: aCustomInsight({
    id: customInsight.name,
    ...baseCustomInsightOverrides,
    ...customInsight,
  }),
});

export const getMockCustomInsightsQueryOperation = (
  customInsight: Partial<CustomInsight>
) => {
  const customInsights = aCustomInsightPage().objects;
  return {
    __typename: 'Query',
    customInsights: aCustomInsightPage({
      objects: [
        ...customInsights,
        aCustomInsight({
          id: customInsight.name,
          ...baseCustomInsightOverrides,
          ...customInsight,
        }),
      ],
    }),
  };
};

export const handlers = [
  mockCustomInsightQueryQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          customInsight: aCustomInsight(),
        },
      });
    }
  ),
  mockCustomInsightsQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          customInsights: aCustomInsightPage(),
        },
      });
    }
  ),
];
